export default __webpack_public_path__ + "static/media/volume-100.bcf49e31.svg";